module.exports = __webpack_public_path__ + "img/grid-picture-2x2.1c00f789.jpg";